import { render, staticRenderFns } from "./DateRangesPicker.vue?vue&type=template&id=655e16d0&scoped=true"
import script from "./DateRangesPicker.vue?vue&type=script&lang=js"
export * from "./DateRangesPicker.vue?vue&type=script&lang=js"
import style0 from "./DateRangesPicker.vue?vue&type=style&index=0&id=655e16d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e16d0",
  null
  
)

export default component.exports
import QField from 'quasar/src/components/field/QField.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QField,QChip,QPopupProxy,QDate,QMenu});
